import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";

interface DraggableComponent {
    title: string;
    isInFront: boolean;
}

export interface DragStore {
    draggableComponents: DraggableComponent[];
    setActiveDraggableComponent: (title: string) => void;
}

export const useDragStore = create<DragStore>()(
    immer(
        devtools(
            (set) => ({
                draggableComponents: [
                    { title: "Notepad", isInFront: false },
                    { title: "Ozmo", isInFront: false },
                ],
                setActiveDraggableComponent: (title: string) => {
                    set(
                        (state) => {
                            // make sure the component is defined in the available components
                            if (state.draggableComponents.find((component) => component.title === title)) {
                                state.draggableComponents = state.draggableComponents.map((component) => ({
                                    ...component,
                                    isInFront: component.title === title,
                                }));
                            }
                        },
                        false,
                        "setActiveDraggableComponent",
                    );
                },
            }),
            {
                enabled: import.meta.env.VITE_ENV_TYPE !== "production",
                store: "drag-store",
                name: "drag-store",
            },
        ),
    ),
);
